import { render, staticRenderFns } from "./HistoryAndRevisionsPanel.vue?vue&type=template&id=a9e2c560&"
import script from "./HistoryAndRevisionsPanel.vue?vue&type=script&lang=ts&"
export * from "./HistoryAndRevisionsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryAndRevisionsPanel.vue?vue&type=style&index=0&id=a9e2c560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports